export default __webpack_public_path__ + "static/media/photo--sm--32.90ce5463.jpg";